import { useEffect } from 'react';
import useAppState from '../../../common/state/appState';
import { CarTilesCarousel } from '../../../components/carousels/car-tiles/CarTilesCarousel/CarTilesCarousel';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import HomePageExperience from '../hero/store/HomePageExperience';
import Box from '@mui/material/Box';
import { CarouselButtons } from '../../../components/CarouselButtons';

interface IYouMightLikeContainerProps {
    variant?: 'test';
}

export const YouMightLikeContainer = ({ variant }: IYouMightLikeContainerProps) => {
    const isLoading = useAppState((state) => state.isLoading);
    const experience = useAppState((state) => state.experience);
    const recentlyViewedVehicles = useAppState((state) => state.recentlyViewedVehicles);
    const favoriteVehicles = useAppState((state) => state.favoriteVehicles);
    const recommendedVehicles = useAppState((state) => state.recommendedVehicles);
    const homeBaseOptimizationGroup = useAppState((state) => state.homebaseOptimizationGroup);

    const setFavoriteVehicles = useAppState((state) => state.setFavoriteVehicles);
    const setRecommendedVehicles = useAppState((state) => state.setRecommendedVehicles);

    //todo : take another look when productionalizing: naming, how to separate hero instance from body instance
    const showOptTestContent = homeBaseOptimizationGroup === 'test' && variant === 'test';

    useEffect(() => {
        if (!isLoading && favoriteVehicles.length === 0) {
            setFavoriteVehicles();
        }
    }, [isLoading, favoriteVehicles.length, setFavoriteVehicles]);

    useEffect(() => {
        if (!isLoading && favoriteVehicles.length > 0 && recommendedVehicles.length === 0) {
            setRecommendedVehicles();
        }
    }, [isLoading, favoriteVehicles.length, recommendedVehicles.length, setRecommendedVehicles]);

    if (experience === HomePageExperience.FirstTimeVisitor) {
        return null;
    }

    if (recommendedVehicles.length > 0) {
        return (
            <Stack
                spacing={2}
                sx={{
                    display: {
                        sm: showOptTestContent ? 'block' : 'none',
                        ['.tns-item']: { paddingRight: '1rem !important' },
                        ['.tns-ovh']: {
                            minHeight: '367px !important',
                            height: 'unset !important',
                        },
                    },
                    px: showOptTestContent ? 0 : 3,
                    pt: showOptTestContent ? 6 : 8,
                }}
            >
                <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
                    <Typography component="h2" sx={{ mt: 0, typography: showOptTestContent ? 'h4' : 'h5' }}>
                        You might like
                    </Typography>
                    <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                        <CarouselButtons sectionIdPrefix="you-might-like" ariaText="You might like" />
                    </Box>
                </Stack>
                <CarTilesCarousel
                    isLoading={isLoading}
                    carouselId="you-might-like"
                    vehiclesData={recommendedVehicles}
                    isRemoveEnabled={false}
                    sectionName="You might like"
                    nextFocus="social-proof-carousel"
                />
            </Stack>
        );
    }

    return null;
};
